// The one public inbox. plugmonkey.xyz receives mail through Cloudflare Email
// Routing (MX → route*.mx.cloudflare.net), which forwards it on. Receive-only:
// nothing on the site sends as this address.
//
// The contact form at /support/ stays the primary route — it pre-categorises
// messages by subject — and this is the fallback for anyone who prefers email.
export const SUPPORT_EMAIL = "support@plugmonkey.xyz";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
